// Mock data para produtos - IMAGENS REAIS dos concorrentes
export const produtos = [
  // IMAGENS REAIS DO CLIENTE
  {
    id: 1,
    nome: 'Piscina de Bolinhas Colorida',
    categoria: 'Piscinas',
    imagem: 'https://customer-assets.emergentagent.com/job_881eaa2f-4116-4ff9-837f-58aefc0a74da/artifacts/su0ng6yq_WhatsApp%20Image%202026-02-05%20at%2000.05.46%20%281%29.jpeg',
    descricao: 'Piscina de bolinhas espumada desmontável, ideal para áreas de recreação infantil com segurança total.',
    dimensoes: '120x120x30cm',
    destaque: true
  },
  {
    id: 2,
    nome: 'Conjunto Mesa e Cadeiras Espumadas',
    categoria: 'Mobiliário',
    imagem: 'https://customer-assets.emergentagent.com/job_881eaa2f-4116-4ff9-837f-58aefc0a74da/artifacts/x1bm2zqg_WhatsApp%20Image%202026-02-05%20at%2000.05.46.jpeg',
    descricao: 'Mesa e cadeiras coloridas espumadas, perfeitas para atividades educativas e recreação segura.',
    dimensoes: 'Mesa: 60x60x50cm',
    destaque: true
  },
  {
    id: 3,
    nome: 'Túnel Sensorial Colorido',
    categoria: 'Circuitos',
    imagem: 'https://customer-assets.emergentagent.com/job_881eaa2f-4116-4ff9-837f-58aefc0a74da/artifacts/i3jet6yg_28212add-ff94-4c8b-acf1-c15aa1037d22.JPG',
    descricao: 'Túnel sensorial para desenvolvimento da propriocepção, planejamento motor e coordenação.',
    dimensoes: 'Comprimento variável',
    destaque: true
  },

  // IMAGENS REAIS DA PULE BRINK
  {
    id: 4,
    nome: 'Cama Elástica 3,05m Lona Preta',
    categoria: 'Cama Elástica',
    imagem: 'https://cdn.sistemawbuy.com.br/arquivos/0cdb0853f7f5ea44e3c6731b7cc8da14/produtos/6674a8e6bcbf2/cama-elastica-305-m-canguri-lona-preta-importada-1-6674a907cb82c.jpg',
    descricao: 'Cama elástica profissional com lona preta resistente, estrutura reforçada e rede de proteção.',
    dimensoes: 'Diâmetro 3,05m',
    destaque: true
  },
  {
    id: 5,
    nome: 'Cama Elástica 4,27m Profissional',
    categoria: 'Cama Elástica',
    imagem: 'https://cdn.sistemawbuy.com.br/arquivos/0cdb0853f7f5ea44e3c6731b7cc8da14/produtos/6674a93787f67/cama-elastica-427-m-6-pes-canguri-lona-preta-importada-1-6674a97a848a4.jpg',
    descricao: 'Cama elástica grande 4,27m com 4 pés, lona preta e estrutura super resistente.',
    dimensoes: 'Diâmetro 4,27m',
    destaque: false
  },
  {
    id: 6,
    nome: 'Playground Fun Play',
    categoria: 'Playground',
    imagem: 'https://cdn.sistemawbuy.com.br/arquivos/0cdb0853f7f5ea44e3c6731b7cc8da14/produtos/6674aac5207a3/playground-fun3-6674ab7ccb2ea.jpg',
    descricao: 'Playground modular completo com plataforma, telhado, 2 escaladas, túnel e escorregador curvo.',
    dimensoes: '370x214x305cm',
    destaque: true
  },

  // PRODUTOS COM DESCRIÇÕES REAIS (sem imagens específicas ainda)
  {
    id: 7,
    nome: 'Caminha Montessori Solteiro',
    categoria: 'Mobiliário',
    imagem: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600',
    descricao: '100% espuma D26 e corino antialérgico, estrutura baixa método Montessori. Inclui colchão.',
    dimensoes: '208x108x25cm',
    destaque: false
  },
  {
    id: 8,
    nome: 'Ponte Arco-Íris 5 Degraus',
    categoria: 'Circuitos',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=600',
    descricao: 'Ponte com 5 degraus coloridos e 2 laterais em arco-íris. Espuma D26, ideal para psicomotricidade.',
    dimensoes: '104x62x40cm',
    destaque: false
  },
  {
    id: 9,
    nome: 'Playground Espumado Borboleta',
    categoria: 'Circuitos',
    imagem: 'https://images.unsplash.com/photo-1576668174940-75cb03a0897e?w=600',
    descricao: 'Kit 6 peças: escada, rampa e asas decorativas temáticas. Perfeito para áreas infantis.',
    dimensoes: '150x130x30cm',
    destaque: false
  },
  {
    id: 10,
    nome: 'BrincaSofá Mil Formas',
    categoria: 'Mobiliário',
    imagem: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600',
    descricao: 'Kit modular 6 peças: 2 colchonetes, 2 triângulos e 2 almofadas. Múltiplas configurações.',
    dimensoes: 'Kit 6 peças',
    destaque: false
  },
  {
    id: 11,
    nome: 'Gira Gira 8 Lugares',
    categoria: 'Playground',
    imagem: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600',
    descricao: 'Gira-gira tradicional de ferro para 8 crianças, estrutura reforçada e pintada.',
    dimensoes: 'Ferro tradicional',
    destaque: false
  },
  {
    id: 12,
    nome: 'Navio dos Piratas',
    categoria: 'Playground',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=600',
    descricao: 'Design diferenciado com timão, escada, escorregador e porão esconderijo. Promove imaginação.',
    dimensoes: '250x262x226cm',
    destaque: false
  },
  {
    id: 13,
    nome: 'Castelo Medieval',
    categoria: 'Playground',
    imagem: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600',
    descricao: 'Playground temático medieval com torres, escorregadores e área de imaginação.',
    dimensoes: 'Grande',
    destaque: false
  },
  {
    id: 14,
    nome: 'Balanço Duplo Plástico',
    categoria: 'Playground',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=600',
    descricao: 'Balanço para 2 crianças com estrutura em plástico resistente e seguro.',
    dimensoes: 'Para 2 lugares',
    destaque: false
  },
  {
    id: 15,
    nome: 'Gangorra 3 Pranchas',
    categoria: 'Playground',
    imagem: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600',
    descricao: 'Gangorra de ferro com 3 pranchas para múltiplas crianças brincarem juntas.',
    dimensoes: 'Ferro',
    destaque: false
  },
  {
    id: 16,
    nome: 'Apoio Bebê para Sentar',
    categoria: 'Área Baby',
    imagem: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600',
    descricao: 'Apoio em formato U para auxiliar bebês na fase de aprender a sentar.',
    dimensoes: '50x40x15cm',
    destaque: false
  },
  {
    id: 17,
    nome: 'Rolo Sensorial',
    categoria: 'Área Baby',
    imagem: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600',
    descricao: 'Rolo para estimulação sensorial e tummy time de bebês. Desenvolvimento motor.',
    dimensoes: '60x30cm diâmetro',
    destaque: false
  },
  {
    id: 18,
    nome: 'Kit Almofadas Educativas',
    categoria: 'Educativo',
    imagem: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600',
    descricao: 'Kit com 15 almofadas: números e símbolos matemáticos. Inclui bolsa organizadora.',
    dimensoes: 'Kit 15 peças',
    destaque: false
  },
  {
    id: 19,
    nome: 'Puff Dobrável 3 em 1',
    categoria: 'Mobiliário',
    imagem: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600',
    descricao: 'Puff multiuso que vira colchonete ou assento. Espuma D26 com revestimento em suede.',
    dimensoes: '180x60x10cm',
    destaque: false
  },
  {
    id: 20,
    nome: 'Túnel Lúdico Centopeia',
    categoria: 'Circuitos',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=600',
    descricao: 'Túnel colorido tipo centopeia para circuitos de atividades e brincadeiras.',
    dimensoes: 'Extensível',
    destaque: false
  }
];

export const instalacoes = [
  {
    id: 1,
    titulo: 'Instalação em Escola Infantil',
    local: 'São Paulo - SP',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=800',
    descricao: 'Playground completo com piscina de bolinhas, circuitos psicomotores e área de descanso.'
  },
  {
    id: 2,
    titulo: 'Espaço Kids em Buffet Infantil',
    local: 'Campinas - SP',
    imagem: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800',
    descricao: 'Área temática com móveis coloridos, equipamentos sensoriais e circuitos de atividades.'
  },
  {
    id: 3,
    titulo: 'Clínica de Fisioterapia Pediátrica',
    local: 'Ribeirão Preto - SP',
    imagem: 'https://images.unsplash.com/photo-1576668174940-75cb03a0897e?w=800',
    descricao: 'Circuito terapêutico completo com equipamentos especializados para reabilitação infantil.'
  },
  {
    id: 4,
    titulo: 'Play Area em Condomínio',
    local: 'Campinas - SP',
    imagem: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800',
    descricao: 'Espaço de lazer infantil com diversos módulos de brinquedo e área segura.'
  },
  {
    id: 5,
    titulo: 'Brinquedoteca Corporativa',
    local: 'São Paulo - SP',
    imagem: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=800',
    descricao: 'Espaço kids em empresa com mobiliário espumado e equipamentos educativos.'
  },
  {
    id: 6,
    titulo: 'Centro de Educação Infantil',
    local: 'Jundiaí - SP',
    imagem: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800',
    descricao: 'Instalação completa com circuitos, piscina de bolinhas e área pedagógica.'
  }
];

export const categorias = [
  { nome: 'Todos', slug: 'todos' },
  { nome: 'Piscinas', slug: 'piscinas' },
  { nome: 'Cama Elástica', slug: 'cama elastica' },
  { nome: 'Playground', slug: 'playground' },
  { nome: 'Mobiliário', slug: 'mobiliario' },
  { nome: 'Circuitos', slug: 'circuitos' },
  { nome: 'Área Baby', slug: 'area baby' },
  { nome: 'Educativo', slug: 'educativo' }
];